import { Box, Heading, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { useTransactions } from "../context/TransactionsContext";
import { useCurrentMonth } from "../hooks/useCurrentMonth";
import { formatEuro } from "../utils/helperFunctions";

const COLORS = ["#38A169", "#E53E3E", "#fbb000"]; // green, red, yellow

export const OverviewChart = () => {
  const { transactions } = useTransactions();
  const [showLabels, setShowLabels] = useState(window.innerWidth > 390);
  const currentMonth = useCurrentMonth();

  const filteredTransactions = transactions.filter((t) => {
    const date = new Date(t.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}` === currentMonth;
  });

  useEffect(() => {
    const handleResize = () => {
      setShowLabels(window.innerWidth > 390);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const income = filteredTransactions
    .filter((t) => t.type === "income")
    .reduce((sum, t) => sum + t.amount, 0);

  const expense = filteredTransactions
    .filter((t) => t.type === "expense")
    .reduce((sum, t) => sum + t.amount, 0);

  const saving = filteredTransactions
    .filter((t) => t.type === "saving")
    .reduce((sum, t) => sum + t.amount, 0);

  const data = [
    { name: "Einnahmen", value: income },
    { name: "Ausgaben", value: expense },
    { name: "Sparen", value: saving },
  ];

  return (
    <>
      {filteredTransactions.length !== 0 ? (
        <Box mt={6}>
          <Heading size="md" mb={4}>
            Einnahmen | Ausgaben | Sparen
          </Heading>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={90}
                label={
                  showLabels ? ({ value }) => `${formatEuro(value)}` : false
                }
                labelLine={showLabels}
              >
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <Tooltip formatter={(value: number) => `${value.toFixed(2)} €`} />
              {!showLabels ? <Legend /> : null}
            </PieChart>
          </ResponsiveContainer>
        </Box>
      ) : (
        <Text textAlign="center">
          Es wurden noch keine Einnahmen oder Ausgaben für den Monat eingetragen
        </Text>
      )}
    </>
  );
};
